var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',[_c('a',{attrs:{"href":"/inventory/bookings/"}},[_c('i',{staticClass:"fa fa-cubes"}),_vm._v(" Inventory")])])}]

export { render, staticRenderFns }